import { useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { KeyUri } from "../key";
import { trackEvent } from "../utils/metaPixel";

const CashfreePaymentStatusRide = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const verifyPayment = async () => {
      try {
        const orderId = searchParams.get("order_id");
        const bookingId = searchParams.get("booking_id") || searchParams.get("bookingId");
        const gateway = searchParams.get("gateway") || "cashfree"; // existing links have no gateway param — default stays cashfree

        if (!orderId) {
          navigate("/", {
            replace: true,
            state: { toastType: "error", toastMessage: "Invalid payment response" },
          });
          return;
        }

        const endpoint = gateway === "hdfc"
          ? `${KeyUri.BACKEND_URI}/payments/hdfc/verify`
          : `${KeyUri.BACKEND_URI}/payment/cashfree/verify`;

        const payload = gateway === "hdfc"
          ? { orderId }
          : { orderId, bookingId };

        const response = await axios.post(endpoint, payload);

        if (response.data?.success) {
          // HDFC's generic controller returns { data: booking }; Cashfree's returns { booking }
          const booking = response.data.booking || response.data.data;
          const rideId = booking?._id || bookingId;
          const reference = booking?.booking_id || rideId;

          const storagePrefix = gateway === "hdfc" ? "hdfc_ride" : "cashfree_ride";
          const eventId = sessionStorage.getItem(`${storagePrefix}_event_id`);
          const value = sessionStorage.getItem(`${storagePrefix}_value`);
          const vehicleId = sessionStorage.getItem(`${storagePrefix}_vehicle_id`);

          trackEvent("Purchase", {
            value: Number(value || 0),
            currency: "INR",
            content_ids: [vehicleId],
            content_type: "cab_booking",
            content_name: "Cab Ride",
          }, eventId);

          sessionStorage.removeItem(`${storagePrefix}_event_id`);
          sessionStorage.removeItem(`${storagePrefix}_value`);
          sessionStorage.removeItem(`${storagePrefix}_vehicle_id`);

          alert(`Booking confirmed successfully! Your booking reference is ${reference}`);
          navigate(`/sharedcabbookingconfirmed?rideid=${rideId}&paymentId=${orderId}&gateway=${gateway}`);
        } else {
          alert(response.data?.message || "Payment failed or was not completed.");
          navigate("/");
        }
      } catch (error) {
        console.error(error);
        alert(error?.response?.data?.message || "Payment verification failed.");
        navigate("/");
      }
    };

    verifyPayment();
  }, []);

  return null;
};

export default CashfreePaymentStatusRide;